import { Stack } from '@mantine/core';
import RevisionSection from 'components/forms/revision/fill-out/RevisionSection';
import { IFormSection } from 'pages/revisions-module/template-editor/editors/form/types';
import { useResponsiveDesign } from 'hooks/use-responsive-design';

/**
 * Content of a tab in the revision form.
 */
export default function RevisionTabContent({ sections }: { sections: IFormSection[] }) {
  const { isTablet } = useResponsiveDesign();

  return (
    <Stack spacing={isTablet ? 20 : 40}>
      {sections.map((section) => (
        <RevisionSection key={section.id} section={section} />
      ))}
    </Stack>
  );
}
